import { z } from 'zod';

import {
  QUIZ_TERM_MAX,
  QUIZ_USER_COUNT_MAX,
} from '../constants/quizQuote.const';

const quotePricingPolicySchema = z.object({
  status: z.literal('SUCCESS'),
  data: z.object({
    countryCode: z.literal('KR'),
    currency: z.literal('KRW'),
    displayCurrency: z.literal('KRW'),
    plans: z.object({
      BASIC: z.object({
        displayCurrency: z.literal('KRW'),
        displayFinalPrice: z.number().finite().positive(),
      }),
      PRO: z.object({
        displayCurrency: z.literal('KRW'),
        displayFinalPrice: z.number().finite().positive(),
      }),
    }),
    groupDiscount: z.object({
      planType: z.literal('PRO'),
      unitAmount: z.number().finite().positive(),
      discountRate: z.number().finite().min(0).max(1),
      minUserCount: z.number().int().positive().max(QUIZ_USER_COUNT_MAX),
      minMonthCount: z.number().int().positive().max(QUIZ_TERM_MAX),
    }),
    quoteValidityDays: z.number().int().positive(),
  }),
});

export interface QuotePricingPolicy {
  basicUnitAmount: number;
  proUnitAmount: number;
  groupUnitAmount: number;
  groupDiscountRate: number;
  groupMinUserCount: number;
  groupMinMonthCount: number;
  quoteValidityDays: number;
  basicFirstPurchasePromotion?: {
    discountRate: number;
    maxDiscountMonths: number | null;
  } | null;
}

/** 공개 가격 응답이 한국 견적 안내에 안전하게 쓸 수 있을 때만 정책을 반환한다. */
export function parseQuotePricingPolicy(
  response: unknown,
): QuotePricingPolicy | null {
  const parsed = quotePricingPolicySchema.safeParse(response);
  if (!parsed.success) return null;

  const { data } = parsed.data;
  return {
    basicUnitAmount: data.plans.BASIC.displayFinalPrice,
    proUnitAmount: data.plans.PRO.displayFinalPrice,
    groupUnitAmount: data.groupDiscount.unitAmount,
    groupDiscountRate: data.groupDiscount.discountRate,
    groupMinUserCount: data.groupDiscount.minUserCount,
    groupMinMonthCount: data.groupDiscount.minMonthCount,
    quoteValidityDays: data.quoteValidityDays,
  };
}
